import 'babel-polyfill'

import WPVUE from './wpvue'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VeeValidate from 'vee-validate'

import './plugins/axios'

import App from './App.vue'
import router from './router'
import store from './store/'

import Meta from 'vue-meta'
import VueObserveVisibility from 'vue-observe-visibility'
import lazySizes from 'lazysizes'
import moment from 'moment'


import { sync } from 'vuex-router-sync'
const unsync = sync(store, router)

import pace from 'pace'

import { mapGetters } from 'vuex'

import DynamicHtml from '@/components/elements/DynamicHtml'

Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.use(Meta)
Vue.use(VueObserveVisibility)
Vue.use(VeeValidate)

Vue.component('DynamicHtml', DynamicHtml)


// Google analityc page view tigger for GA
if(process.env.NODE_ENV !== 'development' && typeof ga === 'function'){
	ga('set', 'page', router.currentRoute.path);
	ga('send', 'pageview');

	router.afterEach(( to, from ) => {
		ga('set', 'page', to.path);
		ga('send', 'pageview');
	});
}

router.beforeEach((to, from, next) => {
	if (to && from && to.path === from.path) {
		next();
	} else {
		window.scroll({
			top: 0,
			left: 0,
		});
		$('html').find('.show-up').removeClass('show-up');
		setTimeout(() => {
			next(); // delay page swap
		}, 150);
	}

})

Vue.mixin({
	data() {
		return {
			baseAnimation: 'animated-in',
			svgIcons: {
				'nextArrow': '<svg width="41px" height="11px" viewBox="0 0 41 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Prosjekt/Desktop" transform="translate(-530.000000, -1863.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-2" transform="translate(353.000000, 1829.000000)"><path id="Line" d="M214.724195,39.28 L208.387817,35.7157878 L208.878079,34.8442122 L217.652812,39.78 L208.878079,44.7157878 L208.387817,43.8442122 L214.724195,40.28 L177.260116,40.28 L177.260116,39.28 L214.724195,39.28 Z"></path></g></g></g></svg>',
				'prevArrow': '<svg width="41px" height="11px" viewBox="0 0 41 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Prosjekt/Desktop" transform="translate(-404.000000, -1863.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-2" transform="translate(353.000000, 1829.000000)"><path id="Line-Copy" d="M54.2758053,40.28 L60.6121826,43.8442122 L60.1219214,44.7157878 L51.3471876,39.78 L60.1219214,34.8442122 L60.6121826,35.7157878 L54.2758053,39.28 L91.7398844,39.28 L91.7398844,40.28 L54.2758053,40.28 Z"></path></g></g></g></svg>',
				'preloader': `<svg width="80px"  height="80px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring">
          <circle cx="50" cy="50" ng-attr-r="{{config.radius}}" ng-attr-stroke-width="{{config.width}}" ng-attr-stroke="{{config.stroke}}" ng-attr-stroke-dasharray="{{config.dasharray}}" fill="none" stroke-linecap="round" r="27" stroke-width="7" stroke="#000000" stroke-dasharray="42.411500823462205 42.411500823462205" transform="rotate(60 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
          </circle>
        </svg>`,
			}
		}
	},
	computed: {
		...mapGetters([
			'currentPage',
			'currentPostType',
			'pageIsLoading'
		]),
		pageType() {
			return this.currentPostType
		}
	},
	methods: {

		visibilityChanged(isVisible, entry) {
			if (isVisible && !this.isVisible) {
				this.isVisible = true;
			}
			if (isVisible && !$(entry.target).hasClass('show-up')) {
				$(entry.target).addClass('show-up');
			}
			if (isVisible && this.isVisible && !$(entry.target).hasClass('show-up')) {
				this.isVisible = false;
				this.$nextTick(() => {
					this.isVisible = true;
				})
			}
		}
	},
})

Vue.filter('formatDate', function (value) {
	if (value) {
		return moment(String(value)).format('MM.DD.YY')
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
